
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import HeaderImage from '@xt/www/components/headerImage/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    HeaderImage
  }
})
export default class HeaderGroup extends Vue {
  @Prop({ default: [] }) memberIds: string[]
  @Prop({ default: 26 }) size: number

  get members() {
    return this.memberIds.slice(0, 3)
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
